import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label", "aria-selected", "tabindex"]
const _hoisted_2 = {
  class: "tab-item__title",
  role: "presentation"
}
const _hoisted_3 = {
  key: 0,
  class: "tab-item__subtext"
}

import { computed } from 'vue';

export interface TabItemProps {
	title: string,
	subText?: string,
	disabled?: boolean,
	active?: boolean,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TabItem',
  props: {
    title: {},
    subText: { default: undefined },
    disabled: { type: Boolean, default: false },
    active: { type: Boolean, default: false }
  },
  emits: ['selected'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const tabItemClasses = computed(() => ({
	'tab-item--active': props.active,
	'tab-item--disabled': props.disabled,
}));

const onClick = () => {
	if (!props.disabled) {
		emit('selected');
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['tab-item', tabItemClasses.value]),
    "aria-label": _ctx.title,
    role: "tab",
    type: "button",
    "aria-selected": _ctx.active,
    tabindex: _ctx.disabled ? -1 : 0,
    onClick: _withModifiers(onClick, ["stop"])
  }, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ ...props })), () => [
      _createElementVNode("p", _hoisted_2, [
        _renderSlot(_ctx.$slots, "title", _normalizeProps(_guardReactiveProps({ ...props })), () => [
          _createTextVNode(_toDisplayString(_ctx.title), 1 /* TEXT */)
        ]),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _renderSlot(_ctx.$slots, "suffix-title", _normalizeProps(_guardReactiveProps({ ...props })))
      ]),
      _renderSlot(_ctx.$slots, "subtext", _normalizeProps(_guardReactiveProps({ ...props })), () => [
        (_ctx.subText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.subText) + " ", 1 /* TEXT */),
              _renderSlot(_ctx.$slots, "suffix-subtext", _normalizeProps(_guardReactiveProps({ ...props })))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})